<script>
import { setLocale } from '@vee-validate/i18n'
import storage from '@/plugins/storage'

export default {
  methods: {
    setAllLocale (locale) {
      storage.set('locale', locale)
      setLocale(locale)
      this.$i18n.locale = locale
    }
  }
}
</script>
